import React from "react";

export const EmptyState: React.FC<{ icon: React.ReactNode; label: string }> = ({
  icon,
  label,
}) => (
  <div className="flex flex-col items-center justify-center gap-2 py-6 px-4 bg-gray-50/70 rounded-lg text-gray-400">
    <span className="text-xl">{icon}</span>
    <p className="text-xs">{label}</p>
  </div>
);
